import { registerPlugin } from '@capacitor/core';

import type { USBDetectionPlugin } from '@/plugins/USBDetection/definitions';

const USBDetection = registerPlugin<USBDetectionPlugin>('USBDetection', {
  web: () => import('./web').then((m) => new m.USBDetectionWeb()),
});

export * from './definitions';
export { USBDetection };
export * from './types';
export * from './USBDetectionHook';
